import styled from "styled-components";

import { Colors, Fonts, MediaBreakpoints } from "../../Styles";

export const Wrapper = styled.div`
    width: 100%;
    position: relative;
`

export const Content = styled.div`
    position: absolute;
`

export const BackgroundPicture = styled.picture`
    position: absolute;
    right: -75px;
    top: 20px;
    background-color: #E7F1FD80;
    width: 190px;
    aspect-ratio: 1;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    pointer-events: none;
    
    & > picture {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 50%;
        border-radius: 50%;
        aspect-ratio: 1;
        padding: 7%;
        box-sizing: border-box;
        background-color: #E7F1FD;
    }

    @media screen and ${MediaBreakpoints.small} {
        right: 15px;
        top: 0;
        width: 55%;
    }
    
    @media screen and ${MediaBreakpoints.medium} {
        right: -55px;
        top: 10px;
        width: 210px;
    }
    
    @media screen and (min-width: 770px) {
        right: 5%;
    }

    @media screen and ${MediaBreakpoints.wide} {
        right: 15%;
    }
`

export const Title = styled.h2`
    color: ${Colors.mineShaft};
    font-family: ${Fonts.theinhardt};
    font-size: 23px;
    font-weight: bold;
    line-height: 30px;
    margin: 0;
`

export const Features = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 0;
    padding: 26px 14px 36px;
`

export const Feature = styled.li`
    display: flex;
    gap: 10px;
    color: ${Colors.mineShaft};
    font-family: ${Fonts.theinhardt};
    font-size: 18px;
    line-height: 22px;
`

export const FeatureIcon = styled.span`
    display: flex;
    background-color: ${Colors.mineShaft};
    color: ${Colors.white};
    flex: 0 0 auto;
    font-size: 13px;
    font-weight: bold;
    width: 24px;
    height: 24px;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
`